import React, {Fragment, useState, useEffect} from 'react'
import {Accordion, Button, TextArea, Checkbox, Form, Icon} from 'semantic-ui-react'
import * as moment from 'moment'
import * as StoriesActions from '../../../actions/StoriesActions'
import {useDispatch, useSelector} from 'react-redux';

export const Notification = (props) => {
    const [active, setActive] = useState(false);

    const dispatch = useDispatch();
    const settings = {
        notification_text: '',
        notification_image: '',
        notification_is_scheduled: false,
        notification_scheduled_for_date: moment().add('days', 2).format('YYYY-MM-DD'),
        notification_scheduled_for_time: '15:00',
        ...useSelector(({stories}) => stories.selected.settings)
    }

    const notificationTriggerLoading = useSelector(({stories}) => (typeof stories.selected.notification_trigger_loading !== 'undefined' && stories.selected.notification_trigger_loading));
    const notificationTriggered = useSelector(({stories}) => (typeof stories.selected.notification_trigger !== 'undefined' && stories.selected.notification_trigger !== null)
            ?(typeof stories.selected.notification_trigger.on.toDate === 'function')
                ?stories.selected.notification_trigger.on.toDate()
                :stories.selected.notification_trigger.on
            :null
        );

    return (
        <Fragment>
            <Accordion.Title active={active} onClick={(e) => {
                    setActive(!active);
                }}><Icon name='dropdown' /> Push-Benachrichtigung</Accordion.Title>
            <Accordion.Content active={active}>
                <Form>
                    <label style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>
                        <div style={{flexGrow: 1}}>Text</div>
                        {
                            (settings.notification_text.length > 0)?
                                <span style={{
                                    fontWeight: 'normal'
                                }}>({settings.notification_text.length} Zeichen)</span>
                            :null
                        }
                    </label>
                    <Form.Field>
                        <TextArea disabled={props.readonly?true:null}  value={settings.notification_text} placeholder='Bitte geben Sie einen Text für die Push-Benachrichtigung ein...' onChange={(e) => {
                            dispatch(StoriesActions.update_settings('notification_text', e.target.value));
                        }} />
                    </Form.Field>
                    <label style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>Geplantes senden</label>
                    <Form.Group>
                        <Form.Field>
                            <Checkbox disabled={props.readonly?true:null} toggle label='Automatisch absenden am' onChange={(e, data) => {
                                dispatch(StoriesActions.update_settings('notification_is_scheduled', data.checked));
                            }}
                            checked={settings.notification_is_scheduled}/>
                        </Form.Field>
                    </Form.Group>
                    <Form.Group>
                        <Form.Field>
                            <input disabled={(settings.notification_is_scheduled && !props.readonly)?null:true} type="date" value={settings.notification_scheduled_for_date} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('notification_scheduled_for_date', target.value));
                            }} />
                        </Form.Field>
                        <Form.Field>
                            <input disabled={(settings.notification_is_scheduled && !props.readonly)?null:true} type="time" value={settings.notification_scheduled_for_time} onChange={({target}) => {
                                dispatch(StoriesActions.update_settings('notification_scheduled_for_time', target.value));
                            }}/>
                        </Form.Field>
                    </Form.Group>
                    {
                        (props.readonly)?
                            
                            (notificationTriggered !== null)?
                                <div style={{
                                    color: '#00A700'
                                }}>
                                    Benachrichtung {moment(notificationTriggered).fromNow()} gesendet.
                                </div>
                            :
                                <Button loading={notificationTriggerLoading?true:null} disabled={notificationTriggerLoading?true:null} fluid color="green" icon="bullhorn" labelPosition="left" content="Benachrichtigung jetzt absenden" onClick={(e) => {
                                    dispatch(StoriesActions.trigger_push(props.storyId, props.draftId));
                                }} />
                        :null
                    }
                </Form>
            </Accordion.Content>
        </Fragment>
    )
}